import React, { useEffect, useState } from "react";
import FooterLogo from "@/assets/img/logo.png";
import { ChevronRight } from "lucide-react";

const Footer: React.FC = () => {
  const [merchant, setMerchant] = useState<string | null>(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const selectedBranch = localStorage.getItem("selectedBranch");
    if (selectedBranch) {
      const branch = JSON.parse(selectedBranch);
      setMerchant(branch.name);
    }
  }, []);

  return (
    <footer className="bg-white text-black w-full mt-auto">
      <div className="max-w-6xl mx-auto py-8 sm:px-10 px-5">
        <div className="flex items-center mb-8">
          <a
            href="https://www.redbirdtab.com"
            className="flex items-center space-x-2"
          >
            <img src={FooterLogo} alt="Redbird Logo" className="h-10" />
          </a>
        </div>

        <div className="max-w-6xl mx-auto border-t py-4 grid md:grid-cols-2 h-full justify-between w-full grid-cols-1 gap-4">
          <span className="text-sm text-gray-800">
            {merchant
              ? `© ${merchant} - ${currentYear}, All Rights Reserved.`
              : `© Redbird - ${currentYear}, All Rights Reserved.`}
          </span>
          <ul className="flex justify-start md:justify-end text-sm">
            <li className="mr-3 md:mx-4">
              <a
                href="https://www.redbirdtab.com/privacy-policy"
                className="group inline-flex cursor-pointer items-center justify-start gap-1 text-gray-600 duration-200 hover:text-black"
              >
                Privacy Policy
                <ChevronRight className="h-4 w-4 translate-x-0 transform opacity-0 transition-all duration-300 ease-out group-hover:translate-x-1 group-hover:opacity-100" />
              </a>
            </li>
            <li className="mr-3 md:mx-4">
              <a
                href="https://www.redbirdtab.com/terms-and-conditions"
                className="group inline-flex cursor-pointer items-center justify-start gap-1 text-gray-600 duration-200 hover:text-black"
              >
                Terms of Service
                <ChevronRight className="h-4 w-4 translate-x-0 transform opacity-0 transition-all duration-300 ease-out group-hover:translate-x-1 group-hover:opacity-100" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
